import { z } from "zod";
import { API, graphqlOperation } from "aws-amplify";
import { Observable } from "zen-observable-ts";

import { updatedTransfer } from "src/graphql/subscriptions";
import { UpdatedTransferSubscription } from "src/API";

import { useEffect, useState } from "react";

const UpdatedTransferSchema = z.object({
    id: z.string(),
    isSettled: z.boolean(),
    isError: z.boolean().or(z.null()),
});

export const useTransferSubscription = (
    transferId: string,
) => {
    const [status, setStatus] = useState<string | null>(null);

    useEffect(() => {
        const subscription = (
            API.graphql(
                graphqlOperation(updatedTransfer, { id: transferId })
            ) as Observable<any>
        ).subscribe({
            next: ({ value }) => {
                const { data } = value;
                const { updatedTransfer } = data as UpdatedTransferSubscription;
                try {
                    UpdatedTransferSchema.parse(updatedTransfer);
                    if (
                        updatedTransfer?.isSettled !== null &&
                        updatedTransfer?.id === transferId
                    ) {
                        if (!updatedTransfer.isError && !updatedTransfer.isSettled) {
                            setStatus("PENDING");
                        }
                        if (updatedTransfer.isError) {
                            setStatus("ERROR");
                        }
                        if (updatedTransfer.isSettled) {
                            setStatus("PAID");
                        }
                    }
                } catch (error) {
                    console.warn(error);
                }
            },
            error: (error) => console.warn(error),
        });
        return () => subscription.unsubscribe();
    }, [transferId]);

    return { status };
};
